export default function (idName, containerToAnimate, className) {
  $(window).on('scroll', function () {
    let animatedElement = $(idName)[0];
    let rect = animatedElement.getBoundingClientRect();
    let windowHeight = $(window).height();

    if (rect.top >= 0 && rect.bottom <= windowHeight) {
      $(idName).addClass(className);
      $(containerToAnimate).addClass(className);
    }
  });
}
